import { heroAside, leadStory } from '@/mocks/home';

export default function HeroSplit() {
  return (
    <section id="focus" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-6 md:px-6 md:py-8">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-6">
          <article className="flex animate-fade-up flex-col justify-between rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-7">
            <div>
              <div className="flex flex-wrap items-center gap-3">
                <span className="rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold tracking-wide text-background-50">
                  {leadStory.tag}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-foreground-600">
                  <i className="ri-fire-line text-accent-600" aria-hidden="true"></i>
                  热度 {leadStory.heat}
                </span>
              </div>

              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                {leadStory.title}
              </h2>

              <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                {leadStory.summary}
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-between gap-4 border-t border-background-300 pt-4">
              <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-600">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line" aria-hidden="true"></i>
                  {leadStory.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {leadStory.time}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-chat-3-line" aria-hidden="true"></i>
                  {leadStory.comments} 条讨论
                </span>
              </div>
              <a
                href="#entry"
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                直达专区入口
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </article>

          <div className="relative h-64 w-full animate-fade-up overflow-hidden rounded-lg md:h-80 lg:h-full lg:min-h-[380px]">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20hero%20artwork%2C%20dramatic%20composition%20of%20overlapping%20torn%20paper%20layers%20and%20halftone%20textures%20in%20deep%20crimson%2C%20brick%20red%20and%20warm%20amber%20against%20a%20cream%20canvas%2C%20cinematic%20lighting%20with%20soft%20vignette%2C%20subtle%20paper%20grain%2C%20magazine%20cover%20art%20direction%2C%20no%20text%2C%20rich%20warm%20tonal%20contrast&width=1200&height=1200&seq=hl-hero-01&orientation=squarish"
              alt="黑料福利专区话题盘点专题配图"
              title="黑料福利专区话题盘点"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" aria-hidden="true"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-accent-950">
                <span className="live-dot block h-1.5 w-1.5 rounded-full bg-accent-950" aria-hidden="true"></span>
                {heroAside.kicker}
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                {heroAside.title}
              </h3>
              <p className="mt-2 text-xs text-background-100/80">{heroAside.meta}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}